import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "../setting.module.css";
import ModalCloseButton from '../../../components/UI/ModalCloseButton';
import { ReactComponent as VectorSuccess } from '../../../utils/assets/Vector_success.svg';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 250,
    backgroundColor: 'var(--primary-popup-background-color)',
    color: 'var(--primary-text-color)',
    borderRadius: '5px',
    p: 4
};

export default function SuccessModal(props) {
    const { setOpen, open, setOpenedPassword } = props
    useEffect(() => {
        setOpenedPassword(false)
        // eslint-disable-next-line
    }, [open]);
    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-1rem" }}>
                            <ModalCloseButton style={{ position: "static" }} onClick={() => setOpen(false)} />
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem" }}>
                            <VectorSuccess/>
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center"}}>
                            <p className={styles.SuccesstModelText}>Your password has now been changed!</p>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}